import React, { useState } from 'react';
import Cookie from 'js-cookie';
import segment from 'common/segment';
import Modal from 'common/components/modals/Modal';

export const COUNTRY_SELECTOR_REDIRECT = 'Country Selector Redirect';
export const COUNTRY_SELECTOR_DISMISS = 'Country Selector Dismiss';

const CountrySelector = props => {
  const {
    header,
    body,
    url,
    redirectStore,
    currentStore,
    redirectStoreFlag,
    currentStoreFlag,
  } = props;
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleRedirect = () => {
    segment.track(COUNTRY_SELECTOR_REDIRECT, {
      redirect_store_iso: redirectStore,
      current_store_iso: currentStore,
    });
    window.location.assign(url);
  };

  const handleStay = () => {
    segment.track(COUNTRY_SELECTOR_DISMISS, {
      redirect_store_iso: redirectStore,
      current_store_iso: currentStore,
    });
    Cookie.set('stay_on_this_store', true);
    setIsModalOpen(false);
  };

  return (
    <Modal
      isOpen={isModalOpen}
      bodyClassName="country-selector__body"
      closable={false}
      shouldCloseOnOverlayClick={false}
    >
      <div className="country-selector__text">
        <h3
          className="center country-selector__header"
          dangerouslySetInnerHTML={{ __html: header }}
        />
        <p dangerouslySetInnerHTML={{ __html: body }} />
      </div>
      <div className="country-selector__items">
        <button className="country-selector__item" onClick={handleRedirect}>
          <img src={redirectStoreFlag} />
        </button>
        <button className="country-selector__item" onClick={handleStay}>
          <img src={currentStoreFlag} />
        </button>
      </div>
    </Modal>
  );
};

export default CountrySelector;
